"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PerspectiveCameraObject = void 0;
const tslib_1 = require("tslib");
const core_1 = require("@openhps/core");
const CameraObject_1 = require("./CameraObject");
let PerspectiveCameraObject = class PerspectiveCameraObject extends CameraObject_1.CameraObject {
    constructor(uid, displayName, width, height, fov = 50, near = 0.1, far = 2000) {
        super(uid, displayName, width, height);
        this.fov = fov;
        this.near = near;
        this.far = far;
    }
};
exports.PerspectiveCameraObject = PerspectiveCameraObject;
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], PerspectiveCameraObject.prototype, "fov", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], PerspectiveCameraObject.prototype, "near", void 0);
tslib_1.__decorate([
    (0, core_1.SerializableMember)(),
    tslib_1.__metadata("design:type", Number)
], PerspectiveCameraObject.prototype, "far", void 0);
exports.PerspectiveCameraObject = PerspectiveCameraObject = tslib_1.__decorate([
    (0, core_1.SerializableObject)(),
    tslib_1.__metadata("design:paramtypes", [String, String, Number, Number, Object, Object, Object])
], PerspectiveCameraObject);
//# sourceMappingURL=PerspectiveCameraObject.js.map